/* global axios */
import ApiClient from './ApiClient';

class KanbanColumnsAPI extends ApiClient {
  constructor() {
    super('kanban_columns', { accountScoped: true });
  }

  reorder(positions) {
    return axios.post(`${this.url}/reorder`, { positions });
  }
}

export default new KanbanColumnsAPI();
